import { useMemo } from 'react';
import {
  GridColDef,
  GridSlotsComponentsProps,
} from '@mui/x-data-grid-pro';
import { DragEventHandler, MouseEventHandler } from 'react';
import { DocumentationViewItem } from 'store/documentation/model/types';

interface UseGridSlotPropsOptions {
  onRowContextMenu: MouseEventHandler<HTMLDivElement>;
  onDragOver: DragEventHandler<HTMLDivElement>;
  onDragLeave: DragEventHandler<HTMLDivElement>;
  onDrop: DragEventHandler<HTMLDivElement>;
  onDragStart: DragEventHandler<HTMLDivElement> | null;
  onDragEnd: DragEventHandler<HTMLDivElement> | null;
  columns: GridColDef<DocumentationViewItem>[];
  tooltipText: string;
}

export function useGridSlotProps({
  onRowContextMenu,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragStart,
  onDragEnd,
  columns,
  tooltipText,
}: UseGridSlotPropsOptions): GridSlotsComponentsProps {
  return useMemo(
    () => ({
      columnsManagement: {
        disableShowHideToggle: false,
        disableResetButton: true,
        getTogglableColumns: () => columns.map((column) => column.field),
      },
      loadingOverlay: {
        variant: 'skeleton',
        noRowsVariant: 'skeleton',
      },
      row: {
        onContextMenu: onRowContextMenu,
        style: { cursor: 'context-menu' },
        draggable: true,
        onDragOver,
        onDragLeave,
        onDrop,
        ...(onDragStart ? { onDragStart } : {}),
        ...(onDragEnd ? { onDragEnd } : {}),
        'data-tooltip-text': tooltipText,
      },
      basePopper: {
        placement: 'bottom-end',
      },
      baseTextField: { variant: 'outlined', size: 'small' },
      baseSelect: { variant: 'outlined', size: 'small' },
    }),
    [
      onRowContextMenu,
      onDragOver,
      onDragLeave,
      onDrop,
      onDragStart,
      onDragEnd,
      columns,
      tooltipText,
    ]
  );
}
